"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Models = void 0;
class Models {
    static Request;
    static Response;
    static FullResponse;
    static IsConnectedRequest;
    static IsLockedRequest;
    static SignInRequest;
    static IsOpenRequest;
    static SignRequest;
    static VersionRequest;
    static NetworkRequest;
    static UserRequest;
    static AddressRequest;
    static VerifyRequest;
    static SignAndSubmitRequest;
    static SubmitRequest;
    static EncryptRequest;
    static DecryptRequest;
    static IsConnectedResponse;
    static IsLockedResponse;
    static SignInResponse;
    static IsOpenResponse;
    static SignResponse;
    static VersionResponse;
    static AddressResponse;
    static NetworkResponse;
    static UserResponse;
    static VerifyResponse;
    static SignAndSubmitResponse;
    static SubmitResponse;
    static IsConnectedFullResponse;
    static IsLockedFullResponse;
    static SignInFullResponse;
    static IsOpenFullResponse;
    static SignFullResponse;
    static VersionFullResponse;
    static AddressFullResponse;
    static NetworkFullResponse;
    static UserFullResponse;
    static VerifyFullResponse;
    static SignAndSubmitFullResponse;
    static SubmitFullResponse;
    static BulkSubmitRequest;
    static BulkSignRequest;
    static BulkSignAndSubmitRequest;
    static BulkSubmitFullResponse;
    static BulkSignFullResponse;
    static BulkSignAndSubmitFullResponse;
    static BulkSubmitResponse;
    static BulkSignResponse;
    static BulkSignAndSubmitResponse;
    static EncryptResponse;
    static EncryptFullResponse;
    static DecryptResponse;
    static DecryptFullResponse;
    static SenderFullResponse;
    static SenderRequest;
    static SenderResponse;
    static ManagerFullResponse;
    static ManagerRequest;
    static ManagerResponse;
    static AllTransactionRequest;
    static AllTransactionResponse;
    static AllTransactionMetadata;
    static AllTxResponse;
    static AllSubmitResponse;
    static AllTransactionStream;
    static AllTransaction;
    static AllFullTransaction;
    static IndexedTransactionRequest;
    static SignTransaction;
    static SignOpts;
    static CryptOpts;
    static ExtendedSignOpts;
    static Status;
}
exports.Models = Models;
//# sourceMappingURL=index.js.map